import { render, staticRenderFns } from "./participants-co-broker.vue?vue&type=template&id=5ccc2ef6"
import script from "./participants-co-broker.vue?vue&type=script&lang=js"
export * from "./participants-co-broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports